import { Button } from '@bambi/component-library/src/components/Button/Button';
import { TrashIcon } from '@heroicons/react/24/outline';

export function DeleteAction({ onDelete }: { onDelete: () => void }) {
  return (
    <div className="mt-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
      <Button
        className="sm:col-span-3"
        onClick={onDelete}
        variant="danger"
        dataTestId="vehicle-delete-button"
      >
        <TrashIcon className="mr-2 w-5" /> Delete this vehicle
      </Button>
    </div>
  );
}
